export default {
  'chargeback.result.title.success': 'Chargeback successfully logged',
  'chargeback.result.description.success': '',

  'chargeback.result.title.warning': 'Chargeback was not logged',
  'chargeback.result.description.warning': '',

  'chargeback.result.title.400.004.014': 'Error logging chargeback',
  'chargeback.result.description.400.004.014':
    'The auth code provided does not match with the auth code of selected payment',

  'chargeback.result.title.400.004.015': 'Error logging chargeback',
  'chargeback.result.description.400.004.015':
    'Order is not eligible for chargeback',

  'chargeback.result.title.400.004.016': 'Error logging chargeback',
  'chargeback.result.description.400.004.016': 'Chargeback already exists',

  'chargeback.result.title.400.004.017': 'Error logging chargeback',
  'chargeback.result.description.400.004.017':
    "Chargeback request date can't be future date",

  'chargeback.result.title.400.004.007': 'Error logging chargeback',
  'chargeback.result.description.400.004.007': 'Checkout payment not found',

  'chargeback.result.title.400.004.008': 'Error logging chargeback',
  'chargeback.result.description.400.004.008':
    'Checkout payment actions not found',

  'chargeback.result.title.400.004.009': 'Error logging chargeback',
  'chargeback.result.description.400.004.009': 'Payment order not found',

  'chargeback.result.title.403.001.001': 'Error logging chargeback',
  'chargeback.result.description.403.001.001':
    'You are not eligible to log a chargeback',

  // Chargeback post actions
  'chargeback-action.result.title.success': 'Chargeback status updated',
  'chargeback-action.result.description.success':
    'Chargeback status updated to {{actionType}} successfully',

  'chargeback-action.result.title.warning': 'Chargeback status was not updated',
  'chargeback-action.result.description.warning': '',

  'chargeback-action.result.title.404.004.010':
    'Chargeback status was not updated',
  'chargeback-action.result.description.404.004.010':
    'Chargeback payment was not found',

  'chargeback-action.result.title.400.004.018':
    'Chargeback status was not updated',
  'chargeback-action.result.description.400.004.018':
    'Chargeback status is invalid',

  'chargeback-action.result.title.undefined':
    'Chargeback status was not updated',
  'chargeback-action.result.description.undefined': 'An error has occurred',

  'chargeback-action.result.title.403.001.001':
    'Chargeback status was not updated',
  'chargeback-action.result.description.403.001.001':
    'You are not eligible to log a chargeback',
};
